import { IVersion } from '@app/models/version';
import { IReportType } from '@app/models/report-type';
import { createAction, props } from '@ngrx/store';


enum ReportTypeActions {
  BeginGetReportTypesByProjectType = '[REPORT TYPE] Begin Get Reports Types By Broject Type',
  GetReportTypesSuccess = '[REPORT TYPE] Get Report Types Success',
  BeginGetVersionByReportType = '[REPORT TYPE] Begin Get Versions By Report Type',
  GetVersionsByReportTypeSuccess = '[REPORT TYPE] Get Versions Success',
  BeginGetReportsProgress = '[REPORT TYPE] Begin Get Reports Progress By Project',
  GetReportProgressSuccess = '[REPORT TYPE] Get Report Progress Success',
  BeginCreateReportType = '[REPORT TYPE] Begin Create Report Type',
  SuccessCreateReportType = '[REPORT TYPE] Success Create Report Type',
  SelectReportType = '[REPORT TYPE] Select Report Type',
  BeginGenerateReportAction = '[REPORT] Begin Generate Report',
  GenerateReportSuccessAction = '[REPORT] Generate Report Success',
  ErrorReport = '[REPORT TYPE] Error'
}

export const BeginGetReportTypesByProjectTypeAction = createAction(
  ReportTypeActions.BeginGetReportTypesByProjectType,
  props<{payload: { projectTypeId: string }}>()
);

export const ReportTypesLoadedAction = createAction(
  ReportTypeActions.GetReportTypesSuccess,
  props<{ payload }>()
);

export const BeginGetVersionsByReportTypeAction = createAction(
  ReportTypeActions.BeginGetVersionByReportType,
  props<{payload: { reportTypeId: string, projectId: string }}>()
);

export const VersionsLoadedAction = createAction(
  ReportTypeActions.GetVersionsByReportTypeSuccess,
  props<{ payload: IVersion[] }>()
);


export const BeginGetReportsProgressAction = createAction(
  ReportTypeActions.BeginGetReportsProgress,
  props<{payload: { projectId: string }}>()
);

export const GetReportProgressSuccessAction = createAction(
  ReportTypeActions.GetReportProgressSuccess,
  props<{ payload }>()
);

export const BeginCreateReportTypeAction = createAction(
  ReportTypeActions.BeginCreateReportType,
  props<{payload: { reportType: IReportType }}>()
);

export const SuccessCreateReportTypeAction = createAction(
  ReportTypeActions.SuccessCreateReportType,
  props<{ payload: { reportType: IReportType} }>()
);

export const SelectReportTypeAction = createAction(
  ReportTypeActions.SelectReportType,
  props<{ payload: { reportType: IReportType} }>()
);

export const BeginGenerateReportAction = createAction(
  ReportTypeActions.BeginGenerateReportAction,
  props<{ payload: {createReportData} }>()
);

export const GenerateReportSuccessAction = createAction(
  ReportTypeActions.GenerateReportSuccessAction,
  props<{ payload: { createdReport: IVersion } }>()
);

export const ErrorReport = createAction(
  ReportTypeActions.ErrorReport, props<Error>()
);
